export default __webpack_public_path__ + "static/media/ssd.dcd58af3.svg";